import {ImageOpNodeMath} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/math/node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/rotate-angle-map/definition"
import {wrap} from "@cm/math"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeRotateAngleMap"}

@registerImageOpNode
export class ImageOpNodeRotateAngleMap extends CompositeImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage, angleInDegrees, angleFactor} = await evaluator.getAll(this.parameters)

        let result: ValueOrNode<AnyImageOpResult> = imageOpNodeBag.getNode("add", ImageOpNodeMath, {
            operandA: sourceImage,
            operandB: wrap((angleFactor * angleInDegrees) / 360, 1),
            operator: "+",
        })
        result = imageOpNodeBag.getNode("mod", ImageOpNodeMath, {
            operandA: result,
            operandB: 0.5,
            operator: "mod",
        })

        return await evaluator.get(result)
    }
}
